import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBell2Snooze: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBell2Snooze"><Path d="M20.49 16.25V17.5H3.5V16.25L5.09 13L5.3 8.83C5.47 5.28 8.43 2.5 12 2.5C15.57 2.5 18.51 5.29 18.69 8.83L18.9 13L20.49 16.25Z" stroke="currentColor" strokeLinecap="square"/><Path d="M10 8H14V8.25L10 12.75V13H14" stroke="currentColor" strokeLinecap="square"/><Path d="M8.00806 17.756C8.14003 19.8459 9.87684 21.5 12 21.5C14.1229 21.5 15.8595 19.8463 15.9919 17.7569" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBell2Snooze;
